import './style/icon-button.less';
import IconButton from './IconButton';

export default IconButton;
